module.exports = __webpack_public_path__ + "img/new.6a9b2a30.png";